import { Text } from '@workwhile/ui'
import React from 'react'
import { useDayforceWebhookDetailContextValue } from '../context/DayforceWebhookDetailProvider'
import { JobDetails } from 'pages/Dayforce/shared/components/JobDetails/JobDetails'

export const JobInvitation = () => {
  const {
    state: { data },
  } = useDayforceWebhookDetailContextValue()

  const payloadData = data?.payloadBase64
    ? JSON.parse(atob(data.payloadBase64))
    : null
  const jobId = payloadData?.data?.job?.id
  const bookingIds = payloadData?.data?.job?.booking_ids

  if (!jobId || !bookingIds) {
    return <Text>Invalid payload</Text>
  }

  return <JobDetails agencyId={data.agencyId} jobId={jobId} />
}
